import { AddonManager } from "../../addon/AddonManager";
import { MaterialManager } from "../../../material/MaterialManager";
import { Main } from "../../../Main";
import { Object3D, Mesh, Vector3 } from "three";

export class GutterDownSpout
{
	public container : Object3D;

	private _enabled : boolean = true;
	private _downspout : Mesh;
	private _kickout   : Mesh;

	private _downspout_top  : Mesh;
	private _downspout_angle : Mesh;

	public static SPACING = 25;

	constructor()
	{
		this.init();
	}

	private init()
	{
		var addonManager = AddonManager.getInstance();
		var material = MaterialManager.getInstance().trim;

		this._downspout = addonManager.createMesh("#0610 - Downspout Profile", material) as Mesh;
		this._downspout.name = "downspout";
		this._kickout   = addonManager.createMesh("#0620 - Downspout Kickout 45deg", material) as Mesh;

		this._downspout_top   = addonManager.createMesh("#0610 - Downspout Profile", material) as Mesh;
		this._downspout_angle = addonManager.createMesh("#0610 - Downspout Profile", material) as Mesh;

		this._downspout.castShadow = true;
		this._downspout_top.castShadow = true;
		this._downspout_angle.castShadow = true;
		this._kickout.castShadow = true;

		//this._downspout.rotation.z = 0;
		//this._downspout_top.rotation.y = Math.PI;
		//this._downspout_angle.rotation.y = Math.PI;
		this._kickout.rotation.y = Math.PI;

		this.container = new Object3D();

		this.container.add(this._downspout);
		this.container.add(this._kickout);

		this.container.add(this._downspout_top);
		//this.container.add(this._downspout_angle);

		Main.getInstance().config.building.gutter.signal.add(this.updateOnOff);
	}

	private updateOnOff = () =>
	{
		this.setEnabled(Main.getInstance().config.building.gutter.value);
	}

	public update(position:Vector3, bottom:number, wallOffset:number)
	{

		var pos = this._downspout.position;
		pos.x = position.x + wallOffset - 0.01;
		pos.y = position.y;
		pos.z = position.z;

		if (wallOffset)
		{
			var top_height = 1.2;

			this._downspout_top.position.x = position.x;
			this._downspout_top.position.y = position.y;
			this._downspout_top.position.z = position.z;

			this._downspout_top.scale.y = top_height;

			this._downspout_angle.position.x = position.x - 0.094;
			this._downspout_angle.position.y = position.y - top_height + 1.067;
			this._downspout_angle.position.z = position.z;

			var angle = 45 * Math.PI / 180;
			this._downspout_angle.scale.y = (wallOffset + 0.09) / Math.cos(angle) * AddonManager.DEFAULT_SCALE;

			this._downspout_angle.rotation.z = angle;

			var angle_height = (wallOffset + 0.22) * Math.tan(angle);
			pos.y -= angle_height;
		}

		var height = pos.y - bottom;

		var showAngle = height > 0 && this._enabled && wallOffset > 0;

		this._downspout_angle.visible = showAngle;
		this._downspout_top.visible = showAngle;


		// downSpout would be too small -> hide it
		if (height < 0)
		{
			this.hide();
			return;
		}

		if (this._enabled)
		{
			this.show();
		}

		this._downspout.scale.y  = height * AddonManager.DEFAULT_SCALE;

		this._kickout.position.x = pos.x;
		this._kickout.position.z = pos.z;
		this._kickout.position.y = pos.y - height + 0.1;
	}

	public setEnabled(value:boolean)
	{
		this._enabled = value;

		if (this._enabled)
		{
			this.show();
		}
		else
		{
			this.hide();
		}
	}

	private hide()
	{
		this.container.remove(this._downspout);
		this.container.remove(this._kickout);
		this.container.remove(this._downspout_top);
		this.container.remove(this._downspout_angle);
	}

	private show()
	{
		this.container.add(this._downspout);
		this.container.add(this._kickout);
		this.container.add(this._downspout_top);
		this.container.add(this._downspout_angle);
	}
}